export const getRemoteConfig = async () => {
  try {
    const data = await fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/config/remote-config`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        next: {
          revalidate: 30 * 60, // 30 minutes
        },
      }
    );

    if (!data.ok) {
      console.error('Error fetching remote config:', data.statusText);
      return null;
    }

    const res = await data.json();

    return res;
  } catch (error) {
    console.error('Error fetching remote config:', error);
  }

  return null;
};
